import { render, staticRenderFns } from "./qualification-result-5g-sq.vue?vue&type=template&id=f7afe47c&scoped=true"
import script from "./qualification-result-5g-sq.vue?vue&type=script&lang=js"
export * from "./qualification-result-5g-sq.vue?vue&type=script&lang=js"
import style0 from "./qualification-result-5g-sq.vue?vue&type=style&index=0&id=f7afe47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7afe47c",
  null
  
)

export default component.exports